export default __webpack_public_path__ + "static/media/forgotpassword.d5141ad4.svg";